import { gql } from '@apollo/client';

const query = gql`
  query localsearchCMSArticle(
    $categoryName: String!
    $articleTitle: String!
    $size: Int
  ) {
    localsearchCMSArticle(
      categoryName: $categoryName
      articleTitle: $articleTitle
      size: $size
    ) {
      results {
        article {
          articleTitle
          articleBlurb
          articleId
          primaryCategoryId
          isQuotableCategory
          primaryCategoryName
          featureImageUrl
          urlSlug
          sectionArray {
            type
            headingTag
            heading
            text
            bulletData
            numberedListData
            columnData
            imageCaption_1
            imageCaption_2
            imageURL_1
            imageURL_2
            numberOfImages
            numberOfColumns
          }
        }
      }
      categories {
        name
        featureImage
      }
    }
  }
`;

module.exports = query;
